export const DOCUMENT_TYPE =
    {
        CI: 0,
        PASSPORT: 1,
        SOCIAL_SECURITY: 2,
        ALIEN_CARD: 3,
        PASSPORT_CARD_US: 4,
        DRIVER_LICENSE: 5,
        ID_OFFICIAL: 6
    }